<template>
  <div class="acct-jurnal-tables">
    <div
      v-for="(group, groupIndex) in groups"
      :key="groupIndex"
      class="acct-table-shell"
      :class="{ 'mb-4': groupIndex < groups.length - 1 }">
      <div class="acct-group-header">
        <div class="acct-group-header__left">
          <span class="acct-group-header__title">Data jurnal</span>
          <span class="acct-group-header__dot">·</span>
          <span class="acct-group-header__number">{{ group.number }}</span>
        </div>
        <div class="acct-group-header__totals">
          <span class="acct-total acct-total--debit">
            <span class="acct-total__label">Debit (Dr)</span>
            <span class="acct-total__value">{{ formatAmount(group.total_debit) }}</span>
          </span>
          <span class="acct-total acct-total--kredit">
            <span class="acct-total__label">Kredit (Cr)</span>
            <span class="acct-total__value">{{ formatAmount(group.total_kredit) }}</span>
          </span>
        </div>
      </div>
      <div class="acct-table-scroll">
        <table class="acct-table acct-table--jurnal">
          <thead class="acct-table__head">
            <tr>
              <th scope="col" class="acct-sticky-left acct-table__th--left">Tanggal</th>
              <th scope="col" class="acct-table__th--left">No Transaksi</th>
              <th scope="col" class="acct-table__th--left">Ref</th>
              <th scope="col">Posisi</th>
              <th scope="col" class="acct-table__th--left">Vendor</th>
              <th scope="col" class="acct-table__th--left">Divisi</th>
              <th scope="col" class="acct-table__th--right">No Akun</th>
              <th scope="col" class="acct-table__th--left">Nama Akun</th>
              <th scope="col" class="acct-table__th--left">Keterangan</th>
              <th scope="col" class="acct-sticky-right-debit acct-table__th--right acct-th--debit">Debit (Dr)</th>
              <th scope="col" class="acct-sticky-right-kredit acct-table__th--right acct-th--kredit">Kredit (Cr)</th>
            </tr>
          </thead>
          <tbody class="acct-table__body">
            <tr
              v-for="(row, rowIndex) in group.detail_array"
              :key="rowIndex"
              class="acct-table__row">
              <td class="acct-sticky-left acct-table__cell--muted">{{ row.datetime | date }}</td>
              <td class="acct-table__cell--mono acct-table__cell--left" :title="group.number" style="font-size: 11px;">{{ group.number }}</td>
              <td class="acct-table__cell--left" style="font-size: 11px;">{{ row.ref || '—' }}</td>
              <td>
                <span
                  v-if="row.position"
                  class="acct-position-badge text-capitalize"
                  style="font-size: 11px;">
                  {{ row.position }}
                </span>
                <span v-else class="acct-table__muted">—</span>
              </td>
              <td class="acct-table__cell--left">
                <span
                  v-if="row.vendor_name"
                  class=""
                  style="font-size: 11px;"
                  :title="row.vendor_name">
                  {{ row.vendor_name }}
                </span>
                <span v-else class="acct-table__muted">—</span>
              </td>
              <td class="acct-table__cell--left">
                <span
                  v-if="row.unit_array && row.unit_array.length > 0"
                  class=""
                  style="font-size: 11px;"
                  :title="formatUnitNames(row.unit_array)">
                  {{ formatUnitNames(row.unit_array) }}
                </span>
                <span v-else class="acct-table__muted">—</span>
              </td>
              <td class="acct-table__cell--mono acct-table__cell--right" style="font-size: 11px;">{{ row.coa_number || '—' }}</td>
              <td class="acct-table__cell--left">
                <span
                  v-if="row.coa_name"
                  class=""
                  style="font-size: 11px;"
                  :title="row.coa_name">
                  {{ row.coa_name }}
                </span>
                <span v-else class="acct-table__muted">—</span>
              </td>
              <td class="acct-table__cell--left">
                <span
                  v-if="row.note"
                  class=""
                  style="font-size: 11px;"
                  :title="row.note">
                  {{ row.note }}
                </span>
                <span v-else class="acct-table__muted">—</span>
              </td>
              <td class="acct-sticky-right-debit acct-table__cell--amount acct-table__cell--mono" style="font-size: 11px;">
                <span :class="isDebitRow(row) ? 'acct-table__cell--debit' : 'acct-table__muted'">
                  {{ formatAmount(row.debit) }}
                </span>
              </td>
              <td class="acct-sticky-right-kredit acct-table__cell--amount acct-table__cell--mono" style="font-size: 11px;">
                <span :class="isKreditRow(row) ? 'acct-table__cell--kredit' : 'acct-table__muted'">
                  {{ formatAmount(row.kredit) }}
                </span>
              </td>
            </tr>
          </tbody>
          <tfoot class="acct-table__foot">
            <tr>
              <td colspan="9" class="acct-sticky-left acct-table__cell--total-label">
                Total (seimbang)
              </td>
              <td class="acct-sticky-right-debit acct-table__cell--total acct-table__cell--mono acct-table__cell--debit">
                {{ formatAmount(group.total_debit) }}
              </td>
              <td class="acct-sticky-right-kredit acct-table__cell--total acct-table__cell--mono acct-table__cell--kredit">
                {{ formatAmount(group.total_kredit) }}
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProjectJurnalTable',
  props: {
    groups: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    formatUnitNames (unitArray) {
      if (!unitArray || !unitArray.length) return '—'
      return unitArray.map(unit => unit.name).join(', ')
    },
    formatAmount (val) {
      const n = Number(val)
      if (!val || isNaN(n) || n === 0) return '—'
      return this.$options.filters.pricing(n)
    },
    isDebitRow (row) {
      return Number(row.debit) > 0
    },
    isKreditRow (row) {
      return Number(row.kredit) > 0
    }
  }
}
</script>

<style scoped>
.acct-table-shell {
  --acct-bg: #ffffff;
  --acct-surface: #f8fafc;
  --acct-head: #e9edf2;
  --acct-footer: #f7f8fa;
  --acct-border: #e0e3e8;
  --acct-text: #1f2933;
  --acct-muted: #4b5563;
  --acct-head-text: #1f2933;
  --acct-debit: #0072B2;
  --acct-kredit: #D55E00;
  --acct-hover: #e8f2f8;
  --acct-stripe: #f3f6fa;
  --acct-sticky-bg: #ffffff;
  --acct-radius: 8px;

  border: 1px solid var(--acct-border);
  border-radius: var(--acct-radius);
  overflow: hidden;
  background: var(--acct-bg);
  color: var(--acct-text);
}

.acct-group-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  padding: 12px 16px;
  background: var(--acct-surface);
  border-bottom: 1px solid var(--acct-border);
}

.acct-group-header__left {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 6px;
  min-width: 0;
}

.acct-group-header__title {
  font-size: 13px;
  font-weight: 600;
  color: var(--acct-text);
}

.acct-group-header__dot { color: var(--acct-muted); }

.acct-group-header__number {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 12px;
  color: var(--acct-muted);
}

.acct-group-header__totals {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.acct-total {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.acct-total__label {
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}
.acct-total__value {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 13px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}
.acct-total--debit .acct-total__label { color: var(--acct-debit); }
.acct-total--debit .acct-total__value { color: var(--acct-debit); }
.acct-total--kredit .acct-total__label { color: var(--acct-kredit); }
.acct-total--kredit .acct-total__value { color: var(--acct-kredit); }

.acct-table-scroll {
  overflow: auto;
  max-height: min(60vh, calc(100vh - 300px));
}

.acct-table--jurnal {
  width: 100%;
  min-width: 1100px;
  table-layout: auto;
  border-collapse: collapse;
  font-size: 13px;
}

.acct-table__head th {
  position: sticky;
  top: 0;
  z-index: 3;
  background: var(--acct-head);
  color: var(--acct-head-text);
  font-size: 11px;
  font-weight: 700;
  padding: 10px 12px;
  text-align: center;
  white-space: nowrap;
  border-bottom: 2px solid var(--acct-border);
  letter-spacing: 0.02em;
}

.acct-th--debit { color: var(--acct-debit); }
.acct-th--kredit { color: var(--acct-kredit); }

.acct-table__th--left { text-align: left; }
.acct-table__th--right { text-align: right; }

.acct-table__body td {
  padding: 9px 12px;
  border-bottom: 1px solid var(--acct-border);
  vertical-align: middle;
  text-align: center;
}

.acct-table__body tr:nth-child(even) td {
  background: var(--acct-stripe);
}

.acct-table__body tr:hover td {
  background: var(--acct-hover) !important;
}
.acct-table__body tr:hover .acct-sticky-left,
.acct-table__body tr:hover .acct-sticky-right-debit,
.acct-table__body tr:hover .acct-sticky-right-kredit {
  background: var(--acct-hover) !important;
}

.acct-table__cell--left { text-align: left; }
.acct-table__cell--right { text-align: right; }
.acct-table__cell--muted { color: var(--acct-muted); font-size: 12px; white-space: nowrap; }
.acct-table__cell--mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 12px;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.acct-table__cell--amount {
  text-align: right;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.acct-table__cell--debit { color: var(--acct-debit); font-weight: 600; }
.acct-table__cell--kredit { color: var(--acct-kredit); font-weight: 600; }
.acct-table__muted { color: var(--acct-muted); }

.acct-position-badge {
  display: inline-block;
  padding: 1px 4px;
  border-radius: 3px;
  font-size: 11px;
  font-weight: 500;
  color: var(--acct-muted);
  background: var(--acct-head);
  border: 1px solid var(--acct-border);
}

.acct-sticky-left {
  position: sticky;
  left: 0;
  z-index: 2;
  background: inherit;
  box-shadow: 2px 0 4px rgba(0, 0, 0, 0.04);
  min-width: 96px;
}
.acct-sticky-right-kredit {
  position: sticky;
  right: 0;
  z-index: 2;
  background: inherit;
  box-shadow: -2px 0 4px rgba(0, 0, 0, 0.04);
  min-width: 100px;
}
.acct-sticky-right-debit {
  position: sticky;
  right: 100px;
  z-index: 2;
  background: inherit;
  min-width: 100px;
}

.acct-table__head .acct-sticky-left,
.acct-table__head .acct-sticky-right-debit,
.acct-table__head .acct-sticky-right-kredit {
  z-index: 4;
  background: var(--acct-head);
}

.acct-table__foot td {
  padding: 10px 12px;
  border-top: 1px solid var(--acct-border);
  background: var(--acct-footer) !important;
  font-weight: 700;
}
.acct-table__cell--total-label {
  text-align: right;
  color: var(--acct-muted);
  font-weight: 600;
  font-size: 12px;
}
.acct-table__cell--total {
  text-align: right;
  font-variant-numeric: tabular-nums;
}

.acct-ellipsis {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-word;
  max-width: 180px;
}
.acct-ellipsis--1 { -webkit-line-clamp: 1; }

@media (max-width: 1264px) {
  .acct-table-scroll { max-height: calc(100vh - 280px); }
}
</style>
